import React from 'react';
import CourseThumbnailSection from '../course/CourseThumbnailSection';
import {
  Edit,
  Trash2,
  Video,
  Users,
  Clock,
  Play
} from 'lucide-react';

const TeacherCourseCard = ({
  course,
  onCourseClick,
  onEditCourse,
  onDeleteCourse,
  isDeleting,
  onNavigateVisuals,
  formatTotalDuration
}) => {
  // ✅ استخدام getImageUrl للصور المرفوعة
  return (
    <div className="group bg-white rounded-[2.5rem] border border-gray-100 overflow-hidden hover:shadow-2xl transition-all duration-500 flex flex-col">
      <CourseThumbnailSection course={course} onClick={onCourseClick} />
      {/* Float Status Badge overlay is kept in body for backward compatibility */}

      {/* Course Info Body */}
      <div className="p-6 flex flex-col flex-1">
        <div className="flex justify-between items-start mb-3">
          <h3 className="text-xl font-black text-gray-900 group-hover:text-primary-600 transition-colors line-clamp-1 flex-1">
            {course.title}
          </h3>
        </div>

        <p className="text-gray-500 text-sm line-clamp-2 mb-6 leading-relaxed flex-1">
          {course.description || 'لا يوجد وصف متاح لهذا الكورس حالياً.'}
        </p>

        {/* Meta Data: students, views (aggregated), duration */}
        <div className="flex items-center justify-between text-[11px] font-bold text-gray-400 mb-6 py-4 border-y border-gray-50">
          <div className="flex items-center gap-1.5">
            <Users size={16} className="text-primary-500" />
            <span>{course.student_count || 0} طالب</span>
          </div>
          <div className="flex items-center gap-1.5">
            <svg className="w-4 h-4 text-primary-500" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            <span>{course.courseViews ?? course.video_views ?? 0} مشاهدة</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Clock size={16} className="text-primary-500" />
            <span>
              {formatTotalDuration ? formatTotalDuration(course) : '0 ثانية'}
            </span>
          </div>
        </div>

        {/* Videos Preview Mini-List */}
        {course.videos?.length > 0 && (
          <div className="mb-6 space-y-2">
            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">أحدث الدروس المرفوعة</p>
            {course.videos.slice(0, 2).map((video) => (
              <div key={video.id} className="flex items-center gap-3 p-2 bg-gray-50 rounded-xl border border-gray-100">
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center text-primary-600 shadow-sm flex-shrink-0">
                  <Play size={14} fill="currentColor" />
                </div>
                <p className="text-xs font-bold text-gray-700 truncate">{video.title}</p>
              </div>
            ))}
            {course.videos.length > 2 && (
              <p className="text-[10px] text-center text-primary-600 font-bold">+{course.videos.length - 2} فيديوهات أخرى</p>
            )}
          </div>
        )}

        {/* Management Actions */}
        <div className="grid grid-cols-4 gap-2 mt-auto">
          <button
            onClick={(e) => { e.stopPropagation(); onNavigateVisuals && onNavigateVisuals(course.id); }}
            className="col-span-2 bg-emerald-50 text-emerald-700 py-3 rounded-xl font-black text-xs hover:bg-emerald-600 hover:text-white transition-all flex items-center justify-center gap-2 border border-emerald-100"
          >
            <Video size={16} /> الفيديوهات
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); onEditCourse(course.id); }}
            className="bg-blue-50 text-blue-700 rounded-xl flex items-center justify-center hover:bg-blue-600 hover:text-white transition-all border border-blue-100"
            title="تعديل"
          >
            <Edit size={18} />
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); onDeleteCourse(course.id); }}
            className="bg-red-50 text-red-600 rounded-xl flex items-center justify-center hover:bg-red-600 hover:text-white transition-all border border-red-100"
            title="حذف"
            disabled={isDeleting}
          >
            <Trash2 size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeacherCourseCard;
